module.exports = __webpack_public_path__ + "static/media/juridico.3683ed49.png";